(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('HoujinSelectDialogController', HoujinSelectDialogController);

    HoujinSelectDialogController.$inject = ['paginationConstants', 'Houjin', '$uibModalInstance'];

    function HoujinSelectDialogController (paginationConstants, Houjin, $uibModalInstance) {

        var vm = this;

        // 翻页所需
        vm.page = 1;
        vm.links = null;
        vm.totalItems = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        // 法人列表
        vm.houjinList = [];

        // 查询条件
        vm.searchData = {name: "", code: "", jigyoushoId: "", id: ""};
        vm.defaultSearchData = {name: "", code: "", jigyoushoId: "", id: ""};

        // 初始加载数据
        vm.loadData = loadData;
        // 点击查询
        vm.search = search;
        // 清空搜索条件
        vm.clear = clear;
        // 选择指定
        vm.select = select;
        // 关闭dialog
        vm.close = close;

        loadData();

        function loadData() {
            Houjin.query({
                page: vm.page - 1,
                name: vm.searchData.name,
                code: vm.searchData.code,
                jigyoushoId: vm.searchData.jigyoushoId,
                id: vm.searchData.id}, function(result, headers){
                vm.totalItems = headers('X-Total-Count');
                vm.houjinList = result;
                vm.queryCount = vm.totalItems;
            });
        }

        function search() {
            vm.page = 1;
            loadData();
        }

        function clear() {
            vm.searchData = angular.copy(vm.defaultSearchData);
            vm.page = 1;
            loadData();
        }

        function select(selected) {
            $uibModalInstance.close(selected);
        }

        function close() {
            $uibModalInstance.close("");
        }
    }
})();
